<template>
  <div class="stage">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-4 font-weight-bold text-capitalize kova-text">Tell Us About Your Project</h4>
        <h6 class="mb-3 font-weight-bold">What do you need an expert for?</h6>

        <!-- <label for="opt1" class="radio text-left">
                    <input type="radio" name="rdo" id="opt1" class="hidden"/>
                    <span class="label"></span>New Project
                </label><br />
                
                <label for="opt2" class="radio text-left">
                    <input type="radio" name="rdo" id="opt2" class="hidden"/>
                    <span class="label"></span>Ongoing Project
                </label><br />
        <hr />-->
        <div class="container-fluid px-0 px-md-4 mb-5">
          <div class="row my-5">
            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedNewProject"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">New Project</h6>
                <font-awesome-icon icon="check-circle" class="checked" v-if="newProject"></font-awesome-icon>
              </div>
            </div>
            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedOngoingProject"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">Ongoing Project</h6>
                <font-awesome-icon icon="check-circle" class="checked" v-if="ongoingProject"></font-awesome-icon>
              </div>
            </div>
          </div>

          <div class="row my-5">
            <div class="col-6 mx-left px-1 px-sm-3 px-md-4">
              <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedCode">
                <h6 class="kova-text font-weight-bolder mx-auto">Code Refactoring/Debugging</h6>
                <font-awesome-icon icon="check-circle" class="checked" v-if="code"></font-awesome-icon>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fc",
  data() {
    return {
      newProject:
        this.$store.state.client.clientData.fcProject === "New Project"
          ? true
          : false,
      isNewProject: false,
      ongoingProject:
        this.$store.state.client.clientData.fcProject === "Ongoing Project"
          ? true
          : false,
      isOngoingProject: false,
      code:
        this.$store.state.client.clientData.fcProject ===
        "Code Refactoring/Debugging"
          ? true
          : false,
      isCode: false,
      fcProject: this.$store.state.client.clientData.fcProject
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { fcProject } = this;
      this.$store.commit("client/updateClient", {
        fcProject
      });
      this.$router.push("description");
    },
    skip() {
      this.$router.push("description");
    },
    clickedNewProject() {
      this.fcProject = "New Project";
      this.newProject = true;
      this.isNewProject = true;
      this.ongoingProject = false;
      this.isOngoingProject = false;
      this.code = false;
      this.isCode = false;
    },
    clickedOngoingProject() {
      this.fcProject = "Ongoing Project";
      this.newProject = false;
      this.isNewProject = false;
      this.ongoingProject = true;
      this.isOngoingProject = true;
      this.code = false;
      this.isCode = false;
    },
    clickedCode() {
      this.fcProject = "Code Refactoring/Debugging";
      this.newProject = false;
      this.isNewProject = false;
      this.ongoingProject = false;
      this.isOngoingProject = false;
      this.code = true;
      this.isCode = true;
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}
.stage-box {
  height: 90px;
  width: 180px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover {
  background-color: #f1f1f1;
}
.checked {
  position: absolute;
  left: 190px;
  font-size: 35px;
  bottom: 45px;
  color: #4bb38e;
}
@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
  .stage-box {
    height: 75px;
    width: 140px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  .checked {
    position: absolute;
    left: 135px;
    font-size: 30px;
    bottom: 45px;
    color: #4bb38e;
  }
}
</style>
